import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/tooltip';
import { APP_STOREFRONT_USE_CASES } from 'constants/app';

import './storefront.scss';

export default class StorefrontUseCases extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
  };

  renderTag(useCase) {
    const useCaseDef = APP_STOREFRONT_USE_CASES.find(
      ({ id }) => id === useCase,
    );
    if (!useCaseDef) {
      return null;
    }

    return (
      <li key={useCase} className="nowrap">
        <Tooltip message={useCaseDef.description} maxTextLineWidth={40}>
          {useCaseDef.label}
        </Tooltip>
      </li>
    );
  }

  render() {
    const { app } = this.props;

    const useCases = app.use_cases; //['direct_to_consumer', 'wholesale'];

    if (!useCases?.length) {
      return null;
    }

    return (
      <div className="storefront-apps-use-cases storefront-apps-tags">
        <ul className="view-body-tags">
          {useCases.map((useCase) => this.renderTag(useCase))}
        </ul>
      </div>
    );
  }
}
